import React, { useState } from 'react';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

import { PendingLimitsItem } from '../PendingLimitsItem';

import style from './PendingLimits.scss';

export const PendingLimits = ({ fetchLimits, limits, translate, isFormLoading }) => {
    const [confirmError, setConfirmError] = useState('');

    return (
        <div className={style.container}>
            <h2 className={style.title}>{translate('title.pending')}</h2>
            <div className={style.limits}>
                {confirmError && <ErrorMessage error={confirmError} className={style.error} animate={true} />}
                {limits.map((limit, key) => (
                    <PendingLimitsItem
                        key={key}
                        limit={limit}
                        fetchLimits={fetchLimits}
                        isFormLoading={isFormLoading}
                        setConfirmError={setConfirmError}
                    />
                ))}
            </div>
        </div>
    );
};
